<p-columnFilter matchMode="equals" showClearButton="false" showMatchModes="false" type="text" [field]="field"
  showMenu="false">
  <ng-template pTemplate="filter" let-value let-filter="filterCallback">
    <input class="input-filter" [formControl]="control" type="text" pInputText (change)="filterInput($event)"
      pSize="small" placeholder="Escribir" />
  </ng-template>
</p-columnFilter>